import { createEffect, createResource, createSignal } from 'solid-js'
import { userId } from '../auth'
import { handleDeleteNotification, handleGetNotifications } from './resources'
import { api, type Notification } from '@here/api'

// State Hook
export function useNotifications() {
	const [notifications, setNotifications] = createSignal<Notification[]>([])
	const [newNotifications, setNewNotifications] = createSignal<boolean>(false)
	// Fetch notifications
	const [notificationsResource, { refetch }] = createResource(
		userId,
		handleGetNotifications,
		{
			initialValue: [],
		},
	)

	// Signal for deleting notification
	const [deleteNotificationId, setDeleteNotification] = createSignal<string | null>(
		null,
	)

	// Resource to delete a notification
	const [deleteNotificationResource] = createResource(
		deleteNotificationId,
		async (id) => {
			const result = await handleDeleteNotification(id)
			if (result?.success) {
				// Refetch notifications after deletion
				refetch()
			}
			return result
		},
	)

	createEffect(() => {
		if (userId()) {
			api()
				.channel('notification') // fixed typo: was 'message_metion'
				.on<Notification>(
					'postgres_changes',
					{
						event: 'INSERT',
						schema: 'public',
						table: 'notification',
						filter: `user_id=eq.${userId()}`,
					},
					(payload) => {
						const notification = payload.new
						setNewNotifications(true)
						// Assuming `mention.id` is the unique key
						setNotifications((prev) => [...prev, notification])
					},
				)
				.subscribe()
		}
	})

	createEffect(() => {
		const notifications = notificationsResource()
		setNotifications(notifications)
	})

	return {
		deleteNotificationResource,
		newNotifications,
		notifications,
		notificationsResource,
		setDeleteNotification,
		setNewNotifications,
	}
}
